<template>
    <Header></Header>
    <Left></Left>
    <section class="container">
        <div class="blue_box _full">
            <div class="box_tit _flex">
                <h2>시민활동관리</h2>
            </div>
            <div class="sch_condition_wrap">
                <div class="left _column _flex">
                    <div class="radio_wrap sch_list">
                        <label for="chk1">
                            <input
                                id="chk1"
                                name="cate"
                                type="radio"
                                :value="1"
                                v-model="state.typeState"
                                @change="
                                    state.page = 1;
                                    getList();
                                "
                            />
                            <em></em>
                            <span>반성매매 시민활동</span>
                        </label>
                        <label for="chk2">
                            <input
                                id="chk2"
                                name="cate"
                                type="radio"
                                :value="3"
                                v-model="state.typeState"
                                @change="
                                    state.page = 1;
                                    getList();
                                "
                            />
                            <em></em>
                            <span>시민활동 제안</span>
                        </label>
                    </div>
                    <div class="_flex _align_bottom _multi">
                        <div class="select_date_wrap">
                            <div class="select_date">
                                <input type="date" @keydown.enter="searchDate" name="" id="" v-model="form_state.startDate" @change="getList" />
                            </div>
                            <div class="select_date">
                                <input
                                    style="margin-left: 5px"
                                    type="date"
                                    @keydown.enter="searchDate"
                                    name=""
                                    id=""
                                    v-model="form_state.endDate"
                                    @change="getList"
                                />
                            </div>
                        </div>
                        <template v-if="state.typeState == 1">
                            <!-- 반성매매 시민활동 -->
                            <div class="search_wrap">
                                <input type="text" placeholder="제목을 입력하세요." v-model="state.searchText" @keyup.enter="getList" />
                                <button type="button" class="search_btn icon_wrap" @click="getList"><img src="img/search_btn.png" alt="" /></button>
                            </div>
                        </template>
                        <template v-if="state.typeState == 3">
                            <!-- 시민활동 제안 -->
                            <div class="select_tab_box_wrap">
                                <div class="select_tab_box _130">
                                    <div
                                        class="selected_tab"
                                        :class="[state.isShowOfferActive ? 'active' : '']"
                                        @click="state.isShowOfferActive = !state.isShowOfferActive"
                                    >
                                        <span>{{ state.searchTypeTxt }}</span>
                                    </div>
                                    <div class="tab_option">
                                        <button
                                            v-for="item in offer_active_list"
                                            @click="
                                                state.searchType = item.key;
                                                state.searchTypeTxt = item.value;
                                                state.isShowOfferActive = false;
                                                state.page = 1;
                                                getList();
                                            "
                                        >
                                            {{ item.value }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="search_wrap">
                                <input
                                    type="text"
                                    v-model="state.searchText"
                                    @keyup.enter="
                                        state.page = 1;
                                        getList();
                                    "
                                    placeholder="검색어를 입력하세요."
                                />
                                <button
                                    type="button"
                                    class="search_btn icon_wrap"
                                    @click="
                                        state.page = 1;
                                        getList();
                                    "
                                >
                                    <img src="img/search_btn.png" alt="" />
                                </button>
                            </div>
                        </template>
                    </div>
                </div>
                <template v-if="state.typeState === 1">
                    <!-- 반성매매 시민활동 & 시민활동 제안 -->
                    <div class="right _align_bottom _flex">
                        <button type="button" class="default_btn _blue" @click="addActivity">반성매매 시민활동 등록</button>
                        <button type="button" class="default_btn _gray" @click="isDelete">삭제</button>
                        <button type="button"><img src="img/excel_icon.png" alt=" 엑셀 다운로드" @click="downloadFile" /></button>
                    </div>
                </template>
                <template v-else-if="state.typeState === 3">
                    <!-- 반성매매 시민활동 & 시민활동 제안 -->
                    <div class="right _align_bottom _flex">
                        <button type="button" class="default_btn _gray" @click="isDelete">삭제</button>
                        <button type="button"><img src="img/excel_icon.png" alt=" 엑셀 다운로드" @click="downloadFile" /></button>
                    </div>
                </template>
            </div>

            <template v-if="state.typeState == 1">
                <!-- 반성매매 시민활동 -->
                <div class="common_table custom_scroll medium">
                    <table>
                        <colgroup>
                            <col style="width: 40px" />
                            <col style="width: 100px" />
                            <col />
                            <col style="width: 170px" />
                            <col style="width: 60px" />
                            <col style="width: 60px" />
                            <col style="width: 60px" />
                            <col style="width: 150px" />
                            <col style="width: 150px" />
                            <col style="width: 100px" />
                            <col style="width: 70px" />
                            <col style="width: 80px" />
                            <col style="width: 80px" />
                            <col style="width: 60px" />
                            <col style="width: 60px" />
                            <col style="width: 60px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                    <input type="checkbox" v-model="state.checkAll" @change="toggleAll()" />
                                </th>
                                <th>번호</th>
                                <th>제목</th>
                                <th>작성일</th>
                                <th>모집인원</th>
                                <th>신청인원</th>
                                <th>선발인원</th>
                                <th>모집기간</th>
                                <th>활동기간</th>
                                <th>신청종료</th>
                                <th>진행상태</th>
                                <th>선발상태</th>
                                <th>신청서 양식</th>
                                <th>선발</th>
                                <th>현황</th>
                                <th>수정</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="state.list.length > 0">
                                <tr v-for="(item, idx) in state.list" :key="item.idx">
                                    <td class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                        <label :for="'chk_main' + item.idx" @click.stop>
                                            <input
                                                type="checkbox"
                                                :id="'chk_main' + item.idx"
                                                v-model="state.checkedList"
                                                :value="item.idx"
                                                @click.stop
                                            />
                                        </label>
                                    </td>
                                    <td class="text_center">{{ (state.page - 1) * state.size + (idx + 1) }}</td>
                                    <td class="ellipsis_1 underline">
                                        <a :href="state.userSiteUrl + '/#/activityView/' + item.idx" target="_blank">
                                            {{ item.title }}
                                        </a>
                                    </td>
                                    <td class="p_0 cnt">{{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}</td>
                                    <td class="cnt">{{ !item.cntApply ? 0 : CommonUtils.numberFormat(item.cntApply) }}</td>
                                    <td class="cnt">{{ !item.applyCnt ? 0 : CommonUtils.numberFormat(item.applyCnt) }}</td>
                                    <td class="cnt">{{ !item.pickCnt ? 0 : CommonUtils.numberFormat(item.pickCnt) }}</td>
                                    <td class="p_0 cnt">
                                        <template v-if="item.recruitStartDate && item.recruitEndDate">
                                            {{ CommonUtils.dateFormatYY(new Date(item.recruitStartDate), ".") }}
                                            ~
                                            {{ CommonUtils.dateFormatYY(new Date(item.recruitEndDate), ".") }}
                                        </template>
                                    </td>
                                    <td class="p_0 cnt">
                                        <template v-if="item.activeStartDate && item.activeEndDate">
                                            {{ CommonUtils.dateFormatYY(new Date(item.activeStartDate), ".") }}
                                            ~
                                            {{ CommonUtils.dateFormatYY(new Date(item.activeEndDate), ".") }}
                                        </template>
                                    </td>
                                    <td class="cnt">{{ item.applyDate ? CommonUtils.dateFormatYY(new Date(item.applyDate), ".") : "-" }}</td>
                                    <td class="cnt p_5">{{ strState(item.state) }}</td>
                                    <td class="cnt">{{ item.applyState == 1 ? "완료" : "미완료" }}</td>
                                    <td class="cnt p_5">
                                        <template v-if="item.state === 1">
                                            <button type="button" class="table_btn _blue" @click="showForm(item.idx)">보기</button>
                                            <!-- 신청서 양식 -->
                                        </template>
                                    </td>
                                    <td class="cnt p_5">
                                        <template v-if="item.state > 1 && item.applyState === 0">
                                            <button type="button" class="table_btn _blue" @click="activityRecruitModal(item.idx)">확인</button>
                                            <!-- 선발 -->
                                        </template>
                                    </td>
                                    <td class="cnt p_5">
                                        <template v-if="item.applyState === 1">
                                            <button type="button" class="table_btn _blue" @click="activityStateModal(item.idx)">보기</button>
                                            <!-- 현황 -->
                                        </template>
                                    </td>
                                    <td class="cnt p_5">
                                        <!-- <template v-if="item.state === 1"> -->
                                        <button type="button" class="table_btn _blue" @click="showModal(item.type, item.idx)">수정</button>
                                        <!-- </template> -->
                                    </td>
                                </tr>
                            </template>
                            <tr v-else>
                                <td colspan="15">
                                    <div class="tb_subject" style="text-align: center; width: 100%">데이터가 없습니다.</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
            <template v-if="state.typeState == 3">
                <!-- 시민활동 제안 -->
                <div class="common_table custom_scroll medium">
                    <table>
                        <colgroup>
                            <col style="width: 40px" />
                            <col style="width: 100px" />
                            <col />
                            <col style="width: 120px" />
                            <col style="width: 120px" />
                            <col style="width: 170px" />
                            <col style="width: 170px" />
                        </colgroup>
                        <thead>
                            <tr>
                                <th class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                    <input type="checkbox" v-model="state.checkAll" @change="toggleAll()" />
                                </th>
                                <th>번호</th>
                                <th>제목</th>
                                <th>조회수</th>
                                <th>댓글수</th>
                                <th>작성자</th>
                                <th>작성일</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="state.list.length > 0">
                                <tr v-for="(item, idx) in state.list" :key="item.idx">
                                    <td class="checkbox_wrap cnt p_5 checkbox_wrap2">
                                        <label :for="'chk_' + item.idx" @click.stop>
                                            <input
                                                type="checkbox"
                                                :id="'chk_' + item.idx"
                                                v-model="state.checkedList"
                                                :value="item.idx"
                                                @click.stop
                                            />
                                        </label>
                                    </td>
                                    <td class="text_center">{{ (state.page - 1) * state.size + (idx + 1) }}</td>
                                    <td class="ellipsis_1 underline">
                                        <a :href="state.userSiteUrl + '/#/suggestView/' + item.idx" target="_blank">
                                            {{ item.title }}
                                        </a>
                                    </td>
                                    <td class="text_center">{{ item.viewCnt }}</td>
                                    <td class="text_center">{{ item.commentCnt }}</td>
                                    <td>{{ item.writer }}</td>
                                    <td class="cnt">{{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}</td>
                                </tr>
                            </template>
                            <tr v-else>
                                <td colspan="6">
                                    <div class="tb_subject" style="text-align: center; width: 100%">데이터가 없습니다.</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
            <PageBtn
                v-if="state.list.length !== 0"
                :currentPage="state.page"
                :totalLength="state.totalLength"
                :perPage="state.size"
                :data="state.data"
                @onPaging="handlePageChange"
            ></PageBtn>
        </div>
    </section>
    <ModalDefault
        v-if="state.isShowModal"
        :type="state.modalTab"
        :title="state.modalTitle"
        :content="state.modalContent"
        @close="closeModal"
        @callback="callBackModal"
    ></ModalDefault>

    <FormListModal
        v-if="state.isShowForm"
        :idx="state.idx"
        type="board"
        @close="state.isShowForm = false"
        @callback="
            state.isShowForm = false;
            getList();
        "
    ></FormListModal>

    <ActivityModal
        v-if="state.isActivityShowModal"
        :data="state.activityInfo"
        @close="state.isActivityShowModal = false"
        @callback="
            state.isActivityShowModal = false;
            getList();
        "
    ></ActivityModal>

    <ActivityStateModal
        v-if="state.isShowActivityStateModal"
        :idx="state.itemIdx"
        @close="state.isShowActivityStateModal = false"
        @viewSign="viewSign"
        @exportSign="exportSign"
        @saveForMemo="saveForMemo"
        @exportExcelForActivityApply="exportExcelForActivityApply"
    ></ActivityStateModal>

    <ActivityRecruitModal
        v-if="state.isShowActivityRecruitModal"
        :idx="state.itemIdx"
        @close="state.isShowActivityRecruitModal = false"
        @save="save"
        @viewSign="viewSign"
        @exportSign="exportSign"
    ></ActivityRecruitModal>

    <!-- :idx="state.itemIdx" -->
</template>
<script lang="ts" config>
    import {
        userStore,
        globalStore,
        popupStore,
        reactive,
        watch,
        apiService,
        onMounted,
        router,
        Header,
        Left,
        ModalDefault,
        types,
        onBeforeUnmount,
        getMessageByCode,
        PageBtn,
        CommonUtils,
        FormListModal,
        ActivityModal,
        ActivityStateModal,
        ActivityRecruitModal,
        ActionModal,
    } from "@/BaseComponent";

    export default {
        props: {},
        components: {
            Header,
            Left,
            ModalDefault,

            PageBtn,
            FormListModal,
            ActivityModal,
            ActivityStateModal,
            ActivityRecruitModal,

            ActionModal,
        },
        setup() {
            const global = globalStore();
            const user = userStore();
            const popup = popupStore();

            const state = reactive({
                list: [] as Array<any>,
                idx: 0 as number,

                isShowSearchType: false,
                detailType: null as number | null,
                detailTxt: "전체" as string,
                searchType: "" as string,
                searchText: "" as string,

                data: {},

                page: 1 as number,
                size: 20 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,

                isShowActivityStateModal: false as boolean, // 현황
                isShowActivityRecruitModal: false as boolean, // 선발
                isShowActionModal: false as boolean, // 선발

                startDate: "" as string,
                endDate: "" as string,
                typeState: 1 as number,

                isShowOfferActive: false as boolean,
                searchTypeTxt: "전체" as string,

                checkAll: false as boolean,
                checkedList: [] as Array<number>,

                itemIdx: 0 as number,
                userSiteUrl: process.env.VUE_APP_USER_FRONT_ADDRESS,

                isActivityShowModal: false as boolean,
                activityInfo: {} as any,

                isShowForm: false as boolean,
                isNotice: null as null | number,

                actionIdx: 0 as number,
            });

            const form_state = reactive({
                startDate: "" as string,
                endDate: "" as string,
            });

            const imgError = (e: Event) => {
                const target = e.target as HTMLImageElement;
                if (target) {
                    target.src = require("@/assets/no_img.png");
                }
            };

            onMounted(() => {
                getList();
            });

            onBeforeUnmount(() => {});

            watch(
                () => state.searchText,
                (newVal, oldVal) => {
                    if (oldVal && newVal === "") {
                        getList();
                    }
                },
            );

            watch(
                () => [state.checkedList, state.list],
                () => {
                    state.checkAll = state.checkedList.length > 0 && state.checkedList.length === state.list.length;
                },
            );
            const handlePageChange = (page: number) => {
                state.page = page;
                getList();
            };

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    deleteCheckList();
                }
            };

            const offer_active_list = [
                { id: "0", key: "0", value: "전체" },
                { id: "1", key: "1", value: "게시글 제목" },
                { id: "2", key: "2", value: "작성자" },
            ];

            const getList = async () => {
                state.checkedList = [];
                const param: types.ReqBoardListForActivityManage = {
                    page: state.page,
                    size: state.size,
                    searchType: state.searchType,
                    searchText: state.searchText,

                    type: state.typeState,
                    startDate: state.startDate,
                    endDate: state.endDate,
                };

                const res = await apiService.board.listForActivityManage(param);

                if (res.returnCode === 0) {
                    state.list = res.list.data;
                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                } else {
                    state.list = [];
                    state.totalPage = 0;
                    state.totalLength = 0;
                }
            };

            const searchDate = async () => {
                if (form_state.startDate && form_state.endDate && form_state.endDate < form_state.startDate) {
                    form_state.endDate = "";
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "날짜를 올바르게 선택해주세요.";
                    state.isShowModal = true;
                    return;
                }
                state.startDate = form_state.startDate;
                state.endDate = form_state.endDate;
                state.page = 1;
                getList();
            };

            const strState = (val: number) => {
                switch (val) {
                    case 1:
                        return "대기중";
                    case 2:
                        return "진행중";
                    case 3:
                        return "진행종료";

                    default:
                        return "기타";
                }
            };

            const isDelete = () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    state.modalTab = 5;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const isDeleteForAction = () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    state.modalTab = 5;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const deleteCheckList = async () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    const param: types.ReqIdxList = {
                        idxList: state.checkedList.join(","),
                    };
                    const res = await apiService.board.remove(param);

                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "삭제가 완료되었습니다.";
                        state.isShowModal = true;

                        getList();
                        state.checkedList = [];
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const downloadFile = async () => {
                try {
                    const param: types.ReqActivityManageForExcel = {
                        type: state.typeState,
                        searchType: state.searchType,
                        searchText: state.searchText,
                        startDate: state.startDate,
                        endDate: state.endDate,
                        idxList: String(state.checkedList),
                    };

                    let res = await apiService.board.exportExcelForActivityManage(param);

                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "파일 다운로드 실패";
                    state.isShowModal = true;
                }
            };

            const boardActionModal = async (idx: number | null) => {};

            const activityStateModal = async (idx: number) => {
                state.itemIdx = idx;
                state.isShowActivityStateModal = true;
            };

            const activityRecruitModal = async (idx: number) => {
                state.itemIdx = idx;
                state.isShowActivityRecruitModal = true;
            };

            const actionModal = async () => {
                state.actionIdx = 0;
                state.isShowActionModal = true;
            };

            const viewSign = async (prop: string) => {
                state.modalTab = 11;
                state.modalTitle = "알림";
                state.modalContent = prop;
                state.isShowModal = true;
            };

            const exportSign = async (prop: string) => {
                try {
                    const response = await fetch(prop);
                    const blob = await response.blob();
                    const downloadUrl = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    const fileName = prop.split("/").pop() || "download.png";

                    a.href = downloadUrl;
                    a.download = fileName;
                    document.body.appendChild(a);
                    a.click();

                    document.body.removeChild(a);
                    window.URL.revokeObjectURL(downloadUrl);
                } catch (error) {
                    console.error("이미지 다운로드 실패:", error);
                }
            };

            const save = async (type: number, idx: number, idxList: any) => {
                if (!type) {
                } else {
                    const param: types.ReqBoardApplyPick = {
                        state: type,
                        idxList: idxList.join(","),
                    };

                    const res = await apiService.board.applyPick(idx, param);

                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "완료되었습니다.";
                        state.isShowModal = true;

                        state.isShowActivityRecruitModal = false;
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                }
            };

            const saveForMemo = async (param: types.ReqBoardForMemoForModify) => {
                const res = await apiService.board.modifyForMemo(param);

                if (res.returnCode === 0) {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "완료되었습니다.";
                    state.isShowModal = true;

                    state.isShowActivityStateModal = false;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const exportExcelForActivityApply = async (type: number, idx: number) => {
                try {
                    let res = await apiService.board.exportExcelForActivityApply(type, idx);

                    if (res && res.data) {
                        const blob = new Blob([res.data], {
                            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        });
                        const disposition = res.headers["content-disposition"];
                        let fileName = "download.xlsx";
                        if (disposition) {
                            const match = disposition.match(/filename="?(.+)"?/);
                            if (match && match[1]) {
                                fileName = decodeURIComponent(match[1]);
                            }
                        }
                        const a = document.createElement("a");
                        const url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } catch (err) {
                    console.error("파일 다운로드 실패:", err);
                }
            };

            const toggleAll = () => {
                if (state.checkAll) {
                    state.checkedList = state.list.map((item) => item.idx);
                } else {
                    state.checkedList = [];
                }
            };

            const showModal = async (type: number, idx: number) => {
                const res = await apiService.board.detail(type, idx);

                if (res.returnCode === 0) {
                    switch (type) {
                        case 1:
                            {
                                state.activityInfo = res.data;
                                state.isActivityShowModal = true;
                            }
                            break;
                    }
                }
            };

            const addActivity = () => {
                state.activityInfo = null;
                state.isActivityShowModal = true;
            };

            const showForm = (idx: number) => {
                state.isShowForm = true;
                state.idx = idx;
            };

            return {
                state,
                form_state,
                user,
                router,
                closeModal,
                callBackModal,
                imgError,
                types,

                global,
                popup,
                CommonUtils,
                handlePageChange,
                getList,
                offer_active_list,
                searchDate,
                strState,
                isDelete,
                deleteCheckList,
                downloadFile,
                activityStateModal,
                activityRecruitModal,
                viewSign,
                exportSign,
                save,
                saveForMemo,
                exportExcelForActivityApply,
                toggleAll,
                showModal,
                addActivity,
                showForm,
                actionModal,

                boardActionModal,
                isDeleteForAction,
            };
        },
    };
</script>
<style scoped>
    .search_action {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .is_notice {
        font-weight: 500;
        cursor: pointer;
        color: var(--txt_col);
        font-family: sans-serif;
    }
</style>
